import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// ==================== ROAD REPORTS ====================

export const submitReport = async (reportData) => {
  try {
    const response = await axios.post(`${API}/reports/submit`, reportData);
    return response.data;
  } catch (error) {
    console.error('Error submitting report:', error);
    throw error;
  }
};

export const getAllReports = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.state) params.append('state', filters.state);
    if (filters.verified !== undefined) params.append('verified', filters.verified);
    if (filters.limit) params.append('limit', filters.limit);
    
    const response = await axios.get(`${API}/reports/all?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching reports:', error);
    throw error;
  }
};

export const getReport = async (reportId) => {
  try {
    const response = await axios.get(`${API}/reports/${reportId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching report:', error);
    throw error;
  }
};

export const verifyReport = async (reportId, verifiedBy) => {
  try {
    const response = await axios.put(`${API}/reports/${reportId}/verify`, { verifiedBy });
    return response.data;
  } catch (error) {
    console.error('Error verifying report:', error);
    throw error;
  }
};

export const deleteReport = async (reportId) => {
  try {
    const response = await axios.delete(`${API}/reports/${reportId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting report:', error);
    throw error;
  }
};

export const getReportStats = async () => {
  try {
    const response = await axios.get(`${API}/reports/stats`);
    return response.data;
  } catch (error) {
    console.error('Error fetching stats:', error);
    throw error;
  }
};

// ==================== WEATHER ====================

export const getCurrentWeather = async () => {
  try {
    const response = await axios.get(`${API}/weather/current`);
    return response.data;
  } catch (error) {
    console.error('Error fetching weather:', error);
    throw error;
  }
};

export const getWeatherAlerts = async () => {
  try {
    const response = await axios.get(`${API}/weather/alerts`);
    return response.data;
  } catch (error) {
    console.error('Error fetching weather alerts:', error);
    throw error;
  }
};

// ==================== HEALTH CHECK ====================

export const healthCheck = async () => {
  try {
    const response = await axios.get(`${API}/health`);
    return response.data;
  } catch (error) {
    console.error('Error checking API health:', error);
    throw error;
  }
};
